// extracted by mini-css-extract-plugin
export default {"main":"WrapperContainer_main__k1+o9","headingWrapper":"WrapperContainer_headingWrapper__qCeHS","heading":"WrapperContainer_heading__OOqyE"};